"use client"
import { useEffect, useState } from 'react';
import Section from '@aura-design/system/section';
import Grid from '@aura-design/system/grid';
import Button from '@aura-design/system/button';
import { Content, isFilled } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import { CookieIcon } from '@radix-ui/react-icons';
import { getIntialState, persistState } from '@airplan/utils/persist-state';


type CookiesNoticeProps = {
  doc: Content.CookiesNoticeDocument;
};

const CookiesNotice = ({ doc }: CookiesNoticeProps) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const value = getIntialState('airplan-storage-store-cookie-notice');
    if (value) {
      setShow(false);
    } else {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    persistState('airplan-storage-store-cookie-notice', Date.now());
  };

  if (!show) return null;

  return (
    <div className="fade-slide-up fixed bottom-0 left-0 right-0 z-50">
      <Section container="smesh" subClassName="bg-white shadow rounded-md">
        <div className="aura">
          <Grid col="twelve">
            <div className="span-1 valign">
              <div className="relative m-auto h-3 w-3 rounded-full border-2 border-solid border-dark-blue text-center md:h-5 md:w-5">
                <CookieIcon className="icon h3 action text-dark-blue" />
              </div>
            </div>
            <div className="span-9 content">
              {isFilled.richText(doc.data.text) && (
                <PrismicRichText field={doc.data.text} />
              )}
            </div>
            <div className="span-2 valign">
              {isFilled.keyText(doc.data.button_label) && (
                <Button
                  label={doc.data.button_label}
                  className="text-dark-blue"
                  onClick={handleClose}
                />
              )}
            </div>
          </Grid>
        </div>
      </Section>
    </div>
  );
};

export default CookiesNotice;
